module.exports = __webpack_public_path__ + "img/confused.932c0188.gif";